import { MetaReducer } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { AppState } from '../app.state';
import * as fromAuthReducer from './auth.reducer';
import * as fromAccountReducer from './account.reducer';
import * as fromSharedReducer from './shared.reducer';
import * as fromCampusReducer from './campus.reducer';
import * as fromPaymentReducer from './payment.reducer';
import * as fromSchoolReducer from './school.reducer';
import * as fromStudentReducer from './student.reducer';
import * as fromScheduleReducer from './schedule.reducer';
import * as fromProfessorReducer from './professor.reducer';
import * as fromAddressReducer from './address.reducer';
import { environment } from 'src/environments/environment';

export const reducers = {
  auth: fromAuthReducer.reducer,
  router: routerReducer,
  account: fromAccountReducer.reducer,
  shared: fromSharedReducer.reducer,
  campus: fromCampusReducer.reducer,
  payment: fromPaymentReducer.reducer,
  school: fromSchoolReducer.reducer,
  students: fromStudentReducer.reducer,
  schedule: fromScheduleReducer.reducer,
  professor: fromProfessorReducer.reducer,
  address: fromAddressReducer.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
